import { ICellRendererParams } from 'ag-grid-community';
import { Dropdown } from 'primereact/dropdown';

import { useGetPredictionTechsQuery } from '@/app/services/equipment';
import { Equipment } from '@/types.gql';

export const FreezeTechDropdown = (props: ICellRendererParams) => {
  const { data: techsData } = useGetPredictionTechsQuery({
    where: {
      or: [{ farmlocation: { eq: false } }, { farmlocation: { eq: null } }],
    },
  });

  const handleChange = (value: Equipment) => {
    if (props?.setValue) {
      props?.setValue(value);
    }
  };

  return (
    <Dropdown
      value={props?.value}
      options={techsData}
      optionLabel="name"
      optionValue="id"
      onChange={(e) => handleChange(e.value)}
      editable
      placeholder="Freeze Tech"
      className="small-dropdown"
    />
  );
};
